// import { DataGrid, GridPagination } from "@mui/x-data-grid";
// import React, { useContext, useEffect, useState } from "react";
// // prop-types is a library for typechecking of props
// import PropTypes from "prop-types";
// import {
//   Box,
//   Chip,
//   CircularProgress,
//   Icon,
//   LinearProgress,
//   Stack,
// } from "@mui/material";
// import MaterialBox from "../MaterialBox";
// import MaterialInput from "../MaterialInput";
// import SearchIcon from "@mui/icons-material/Search";
// import CustomizedPagination from "./components/CustomPagination";
// import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
// import MaterialTypography from "../MaterialTypography";
// import { Info } from "@mui/icons-material";
// import Grid from "@mui/material/Grid2";

// // import { motion } from "framer-motion";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import { DesignationContext } from "../../context/designationcontext";
// import { useLocation } from "react-router-dom";
// function CustomPagination(props) {
//   return <GridPagination ActionsComponent={CustomizedPagination} {...props} />;
// }

// const MaterialDataGrid = ({
//   rows,
//   columns,
//   checkboxSelection,
//   onRowClick,
//   customHeight,
//   loading,
//   localeText,
//   isSelectable,
//   noSearch,
//   noPagination,
//   subTab,
//   paginationModel,
//   setPaginationModel,
//   rowCount,
//   disablePagination = false,
// }) => {
//   const [searchText, setSearchText] = useState("");
//   const [searchResults, setSearchResults] = useState([]);

//   const location = useLocation();

//   const [isfilterneeded, setisfilter] = useState(false);

//   const pathtofilter = [
//     "/permission",
//     "/regularization-request",
//     "/wfh-management",
//     "/leave-management",
//   ];

//   useEffect(() => {
//     for (let val of pathtofilter) {
//       if (val == location.pathname) {
//         setisfilter(true);
//       }
//     }
//   }, [location]);

//   const [hasSearched, setHasSearched] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);

//   const enablePagination = rowCount > 0 && rows.length > 0;

//   // const [selectedValue, setSelectedValue] = useState(""); // State to store selected value
//   // const[filteredresults,setFilteredresults] = useState([])
//   // const[columnvalue,setcolumnvalue] = useState('')

//   const {
//     selectedValue,
//     setSelectedValue,
//     filteredresults,
//     setFilteredresults,
//     columnvalue,
//     setcolumnvalue,
//     handleClearSelection,
//     rowdata,
//     setrowdata,
//   } = useContext(DesignationContext);

//   const [uniquevalue, setuniquevalue] = useState([]);

//   const handleArrowClick = () => {
//     document.getElementById("demo-simple-select").focus();
//   };

//   //  handleClearSelection = () => {

//   //   setSelectedValue("");
//   //   setcolumnvalue("")
//   //   setFilteredresults(rowdata)
//   // };

//   const handleChange = (event) => {
//     setSelectedValue(event.target.value);

//     setuniquevalue([...new Set(rows?.map((item) => item[event.target.value]))]);
//   };
//   const handleuniquechange = (event) => {
//     setcolumnvalue(event.target.value);

//     const finalrow = rows?.filter(
//       (row) => row[selectedValue] == event.target.value,
//     );
//     setFilteredresults(finalrow);
//   };

//   useEffect(() => {
//     if (searchText && searchText.length > 1) {
//       const timeoutId = setTimeout(() => {
//         getSearchDetails(searchText);
//       }, 300); // Debounce search
//       return () => clearTimeout(timeoutId);
//     } else {
//       setSearchResults([]); // Reset to all rows if searchText is cleared
//     }
//   }, [searchText, rows]);

//   const scrolltoId = (id) => {
//     const element = document.getElementById(id);
//     if (element) element.scrollIntoView();
//   };

//   const getSearchDetails = async (searchText) => {
//     setSearchResults([]);
//     setIsLoading(true);
//     scrolltoId("search");

//     if (!hasSearched) setHasSearched(true);

//     // Filter rows based on searchText
//     const results = rows.filter((row) => {
//       // Ensure row and its fields are defined before calling .toString()
//       return Object.values(row).some((value) =>
//         value?.toString().toLowerCase().includes(searchText.toLowerCase()),
//       );
//     });

//     setSearchResults(results);
//     setIsLoading(false);
//   };

//   // const columnsData = columns.map((column) => {
//   //     return ({
//   //         field: column.field,
//   //         headerName: <MaterialTypography variant="caption" color="black" fontWeight='mediumn'
//   //             sx={({ typography: { size } }) => ({
//   //                 fontSize: size.sm
//   //             })}
//   //         >
//   //             {column.headerName}
//   //         </MaterialTypography>,
//   //         flex: column.flex,
//   //         width: column.width,
//   //         // disableColumnMenu: true,
//   //         sortable: true,
//   //         renderCell: (params) => (
//   //             column.type === "status" ?
//   //                 <Stack direction="row" alignItems="center" textAlign='center' gap={1} mt={1.5}>
//   //                     <Chip label={params.row.status?.label}
//   //                         size="small"
//   //                         icon={params.row.status?.icon || <Info />}
//   //                         color={params.row.status?.color}
//   //                     />
//   //                 </Stack>
//   //                 :
//   //                 column.type === "images" ?
//   //                     <>
//   //                         <img className='image' src={params.row.image} />
//   //                     </>
//   //                     :
//   //                     <MaterialTypography variant="caption" color="dark"
//   //                         sx={({ typography: { size } }) => ({
//   //                             fontSize: size.sm
//   //                         })}
//   //                     >
//   //                         {params.row[column.field]}
//   //                     </MaterialTypography>
//   //         )
//   //     })
//   // })

//   const columnsData = columns.map((column) => ({
//     field: column.field,
//     headerName:
//       typeof column.headerName === "string" ? column.headerName : column.field,
//     renderHeader:
//       column.headerName && typeof column.headerName === "string"
//         ? () => (
//             <MaterialTypography
//               variant="caption"
//               color="black"
//               fontWeight="medium"
//               sx={({ typography: { size } }) => ({ fontSize: size.sm })}
//             >
//               {column.headerName}
//             </MaterialTypography>
//           )
//         : undefined,
//     flex: column.flex,
//     width: column.width,
//     sortable: true,
//     renderCell: (params) =>
//       column.type === "status" ? (
//         <Stack
//           direction="row"
//           alignItems="center"
//           textAlign="center"
//           gap={1}
//           mt={1.5}
//         >
//           <Chip
//             label={params.row.status?.label}
//             size="small"
//             icon={params.row.status?.icon || <Info />}
//             color={params.row.status?.color}
//           />
//         </Stack>
//       ) : column.type === "images" ? (
//         <img className="image" src={params.row.image} alt="column image" />
//       ) : (
//         <MaterialTypography
//           variant="caption"
//           color="dark"
//           sx={({ typography: { size } }) => ({ fontSize: size.sm })}
//         >
//           {params.row[column.field]}
//         </MaterialTypography>
//       ),
//   }));

//   const finalRows = React.useMemo(() => {
//   if (searchText.length > 1) return searchResults;
//   if (filteredresults?.length > 0) return filteredresults;
//   return rows;
// }, [rows, searchResults, filteredresults, searchText]);


//   return (
//     <MaterialBox>
//       <Grid
//         container
//         alignItems="center"
//         justifyContent="space-between"
//         spacing={2}
//         p={1}
//       >
//         <Grid item xs={12} sm={9}>
//           {subTab && <MaterialBox>{subTab}</MaterialBox>}
//         </Grid>

//         <Grid item xs={12} sm={3}>
//           <MaterialBox display="flex" justifyContent="flex-end" width="100%">
//             {!noSearch && (
//               <MaterialInput
//                 label="Search"
//                 placeholder="Search..."
//                 fullWidth
//                 variant="outlined"
//                 size="medium"
//                 value={searchText}
//                 inputProps={{
//                   maxlength: "15",
//                 }}
//                 onChange={(e) => setSearchText(e.target.value)}
//                 icon={
//                   isLoading
//                     ? {
//                         direction: "right",
//                         component: (
//                           <CircularProgress color="success" size={18} />
//                         ),
//                       }
//                     : {
//                         direction: "right",
//                         component: (
//                           <Icon color="action" fontSize="small">
//                             <SearchIcon />
//                           </Icon>
//                         ),
//                       }
//                 }
//               />
//             )}
//           </MaterialBox>
//         </Grid>
//       </Grid>

//       <Box style={{ height: customHeight ? customHeight : 400, width: "100%" }}>
//         <DataGrid
//           // rows={searchResults?.length>0?searchResults:filteredresults?.length>0?filteredresults:rows}
//           // rows={filteredresults?.length > 0 ? filteredresults:rows}
//           rows={
//           finalRows
//           }
//           columns={columnsData}
//           style={{
//             border: 0,
//             cursor: onRowClick && "pointer",
//           }}
//           // initialState={{
//           //   pagination: {
//           //     paginationModel: {
//           //       pageSize: 10,
//           //     },
//           //   },
//           // }}
//           slots={{
//             // pagination: CustomPagination,
//             loadingOverlay: (props) => (
//               <MaterialBox style={{ overflow: "hidden" }}>
//                 <LinearProgress color="dark" {...props} />
//               </MaterialBox>
//             ),
//           }}
//           loading={loading}
//           //         pagination
//           paginationMode="server"
//           //     pageSizeOptions={[10]}
//           //             paginationModel={paginationModel}
//           onPaginationModelChange={(model) => {
//             setPaginationModel(model);

//             // 🔥 IMPORTANT: clear local overrides
//             setSearchResults([]);
//             setFilteredresults([]);
//             setSearchText("");
//           }}
//           // rowCount={rowCount}

//           {...(enablePagination && {
//             pagination: true,
//             paginationMode: "server",
//             paginationModel,
//             onPaginationModelChange: setPaginationModel,
//             rowCount,
//             pageSizeOptions: [10],
//           })}
//           {...(!enablePagination && {
//             pagination: false,
//             pageSizeOptions: [1000],
//           })}
//           checkboxSelection={checkboxSelection}
//           disableRowSelectionOnClick
//           // rowSelectionModel={false}

//           onRowClick={onRowClick}
//           isSelectable={isSelectable}
//           // getRowHeight={() => 'auto'}
//           density="standard"
//           // disableColumnMenu
//           sx={{
//             "& .MuiDataGrid-virtualScroller::-webkit-scrollbar": {
//               width: "1px",
//               height: "1px",
//             },
//             "& .MuiDataGrid-virtualScroller::-webkit-scrollbar-track": {
//               borderRadius: "5px",
//             },
//             "& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb": {
//               backgroundColor: "grey.400",
//               borderRadius: "10px",
//             },
//             //if isSelectable is true
//             ...(!isSelectable && {
//               "&  .MuiDataGrid-cell": {
//                 //focus color
//                 "&:focus": {
//                   outline: "none",
//                 },
//               },
//             }),
//           }}
//           disableSelectionOnClick
//           // disablePagination={true}
//           localeText={localeText}
//         />
//       </Box>
//     </MaterialBox>
//   );
// };

// // Typechecking props for the MaterialDataGrid
// MaterialDataGrid.propTypes = {
//   rows: PropTypes.number,
//   columns: PropTypes.number,
//   checkboxSelection: PropTypes.bool,
//   isSelectable: PropTypes.bool,
//   loading: PropTypes.bool,
//   isSelectable: PropTypes.bool,
//   onRowClick: PropTypes.func,
//   localeText: PropTypes.object,
// };

// export default MaterialDataGrid;


import { DataGrid, GridPagination } from "@mui/x-data-grid";
import React, { useContext, useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import {
  Box,
  Chip,
  CircularProgress,
  Icon,
  LinearProgress,
  Stack,
} from "@mui/material";
import MaterialBox from "../MaterialBox";
import MaterialInput from "../MaterialInput";
import SearchIcon from "@mui/icons-material/Search";
import CustomizedPagination from "./components/CustomPagination";
import MaterialTypography from "../MaterialTypography";
import { Info } from "@mui/icons-material";
import Grid from "@mui/material/Grid2";
import { DesignationContext } from "../../context/designationcontext";
import { useLocation } from "react-router-dom";

function CustomPagination(props) {
  return <GridPagination ActionsComponent={CustomizedPagination} {...props} />;
}

const MaterialDataGrid = ({
  rows = [],
  columns = [],
  checkboxSelection,
  onRowClick,
  customHeight,
  loading,
  localeText,
  isSelectable,
  noSearch,
  noPagination,
  subTab,
  paginationModel,
  setPaginationModel,
  rowCount,
}) => {
  const [searchText, setSearchText] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [hasSearched, setHasSearched] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const location = useLocation();

  const {
    selectedValue,
    setSelectedValue,
    filteredresults,
    setFilteredresults,
    columnvalue,
    setcolumnvalue,
    handleClearSelection,
    rowdata,
    setrowdata,
  } = useContext(DesignationContext);

  const pathtofilter = [
    "/permission",
    "/regularization-request",
    "/wfh-management",
    "/leave-management",
  ];

  const [isfilterneeded, setisfilter] = useState(false);

  useEffect(() => {
    setisfilter(pathtofilter.includes(location.pathname));
  }, [location]);

  /** ----------------------------------------
   *  Decide pagination mode (SERVER / CLIENT)
   * ---------------------------------------- */
  const isServerPagination =
    paginationModel &&
    typeof setPaginationModel === "function" &&
    typeof rowCount === "number";

  /** ----------------------------------------
   *  Search Logic (CLIENT MODE ONLY)
   * ---------------------------------------- */
  useEffect(() => {
    if (isServerPagination) return;

    if (searchText && searchText.length > 1) {
      const timeoutId = setTimeout(() => {
        getSearchDetails(searchText);
      }, 300);
      return () => clearTimeout(timeoutId);
    } else {
      setSearchResults([]);
    }
  }, [searchText, rows, isServerPagination]);

  const getSearchDetails = (text) => {
    setIsLoading(true);

    if (!hasSearched) setHasSearched(true);

    const results = rows.filter((row) =>
      Object.values(row).some((value) =>
        value?.toString().toLowerCase().includes(text.toLowerCase())
      )
    );

    setSearchResults(results);
    setIsLoading(false);
  };

  /** ----------------------------------------
   *  FINAL ROWS (NO FUNCTIONALITY CHANGE)
   * ---------------------------------------- */
  const finalRows = useMemo(() => {
    if (isServerPagination) return rows;
    if (searchText.length > 1) return searchResults;
    if (filteredresults?.length > 0) return filteredresults;
    return rows;
  }, [rows, searchResults, filteredresults, searchText, isServerPagination]);

  /** ----------------------------------------
   *  Columns
   * ---------------------------------------- */
  const columnsData = columns.map((column) => ({
    field: column.field,
    headerName:
      typeof column.headerName === "string" ? column.headerName : column.field,
    renderHeader:
      column.headerName && typeof column.headerName === "string"
        ? () => (
            <MaterialTypography
              variant="caption"
              color="black"
              fontWeight="medium"
              sx={({ typography: { size } }) => ({ fontSize: size.sm })}
            >
              {column.headerName}
            </MaterialTypography>
          )
        : undefined,
    flex: column.flex,
    width: column.width,
    sortable: true,
    renderCell: (params) =>
      column.type === "status" ? (
        <Stack direction="row" alignItems="center" gap={1} mt={1.5}>
          <Chip
            label={params.row.status?.label}
            size="small"
            icon={params.row.status?.icon || <Info />}
            color={params.row.status?.color}
          />
        </Stack>
      ) : (
        <MaterialTypography
          variant="caption"
          color="dark"
          sx={({ typography: { size } }) => ({ fontSize: size.sm })}
        >
          {params.row[column.field]}
        </MaterialTypography>
      ),
  }));

  return (
    <MaterialBox>
      <Grid container spacing={2} p={1} alignItems="center">
        <Grid xs={12} sm={9}>
          {subTab && <MaterialBox>{subTab}</MaterialBox>}
        </Grid>

        <Grid xs={12} sm={3}>
          {!noSearch && !isServerPagination && (
            <MaterialInput
              label="Search"
              placeholder="Search..."
              fullWidth
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              icon={{
                direction: "right",
                component: isLoading ? (
                  <CircularProgress size={18} />
                ) : (
                  <Icon fontSize="small">
                    <SearchIcon />
                  </Icon>
                ),
              }}
            />
          )}
        </Grid>
      </Grid>

      <Box sx={{ height: customHeight || 400, width: "100%" }}>
        <DataGrid
          rows={finalRows}
          columns={columnsData}
          loading={loading}
          checkboxSelection={checkboxSelection}
          onRowClick={onRowClick}
          disableRowSelectionOnClick
          localeText={localeText}
          density="standard"
          getRowId={(row) => row.id || row._id}

          {...(isServerPagination
            ? {
                pagination: true,
                paginationMode: "server",
                paginationModel,
                onPaginationModelChange: (model) => {
                  setPaginationModel(model);
                  setSearchText("");
                  setSearchResults([]);
                  setFilteredresults([]);
                },
                rowCount,
                pageSizeOptions: [10],
              }
            : {
                pagination: !noPagination,
                pageSizeOptions: [10, 25, 50],
              })}

          slots={{
            loadingOverlay: () => (
              <MaterialBox>
                <LinearProgress color="dark" />
              </MaterialBox>
            ),
          }}

          sx={{
            "& .MuiDataGrid-virtualScroller::-webkit-scrollbar": {
              width: "1px",
              height: "1px",
            },
            ...(!isSelectable && {
              "& .MuiDataGrid-cell:focus": {
                outline: "none",
              },
            }),
          }}
        />
      </Box>
    </MaterialBox>
  );
};

MaterialDataGrid.propTypes = {
  rows: PropTypes.array,
  columns: PropTypes.array,
  checkboxSelection: PropTypes.bool,
  loading: PropTypes.bool,
  onRowClick: PropTypes.func,
  localeText: PropTypes.object,
};

export default MaterialDataGrid;
